import { render } from "./ChapterDetailsView.vue?vue&type=template&id=cee9948a&scoped=true"
import script from "./ChapterDetailsView.vue?vue&type=script&lang=js"
export * from "./ChapterDetailsView.vue?vue&type=script&lang=js"

import "./ChapterDetailsView.vue?vue&type=style&index=0&id=cee9948a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cee9948a"]])

export default __exports__